export const APP_FEATURE_P2P_ENABLED = true;
export const APP_FEATURE_MANAGE_DEVICE_ENABLED = true;
export const APP_FEATURE_HEALTH_JOURNEY_ENABLED = true;
export const APP_FEATURE_DASHBOARD_SCHEDULE_ENABLED = true;
